import { Component } from '@angular/core';
import { Sign } from './sign.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'amysigns';

  constructor(private router: Router) {
  }

  openSign(sign: Sign | undefined) {
    if (sign) {
      this.router.navigate(['sign', sign.id]);
    } else {
      this.router.navigate(['']);
    }
  }
}
